import type { RootState } from '@redux/types';

export const languageSelector = (state: RootState) => state.language.currentLanguage;
